import { Avatar, Flex, Paper, Text } from '@mantine/core';
import dayjs from 'dayjs';

import type { Candidate } from '@entities/candidates';

type PreviewPositiveCandidateProps = {
  candidate: Candidate;
};

export const PreviewPositiveCandidate = ({
  candidate,
}: PreviewPositiveCandidateProps) => {
  const fullName =
    [candidate.firstName, candidate.lastName].filter(Boolean).join(' ') || '—';
  const selectedAt = candidate.candidateVacancyCreatedAt
    ? dayjs(candidate.candidateVacancyCreatedAt).format('DD.MM.YYYY')
    : '—';

  return (
    <Paper p={16} radius={12} bg='primary.0' shadow='none' w='100%'>
      <Flex direction='column' gap={24}>
        <Flex gap={8} align='center' wrap='nowrap'>
          <Avatar
            src={candidate.photo?.absolutePath}
            alt=''
            name={fullName}
            radius='50%'
            size={48}
            flex='0 0 auto'
          />
          <Flex direction='column' gap={4} style={{ flex: 1, minWidth: 0 }}>
            <Text size='md' fw={600} c='primary.7' lineClamp={2}>
              {fullName}
            </Text>
            <Text size='sm' c='tertiary.7'>
              {candidate.phone}
            </Text>
          </Flex>
        </Flex>

        <Text size='sm' c='tertiary.7'>
          {selectedAt}
        </Text>
      </Flex>
    </Paper>
  );
};
